import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

import RichTextareaField from '../RichTextareaField';

export const FormikRichTextareaField = ({
  ...props
}) => {
  const { dirty, initialValues } = useFormikContext();
  const [resetTo, setResetTo] = useState(false);

  useEffect(() => {
    // dirty is set to false when formik resetForm() is called.
    // Pass along the new initialValue to reset pell editor as well.
    if (!dirty) {
      setResetTo(initialValues.description);
    } else {
      setResetTo(false);
    }
  }, [dirty, initialValues, setResetTo]);

  return (
    <RichTextareaField
      isResetting={resetTo}
      richTextEditor
      {...props}
    />
  );
};

FormikRichTextareaField.displayName = 'FormikRichTextareaField';

export default FormikRichTextareaField;
